import { render, staticRenderFns } from "./PurchaseBillView.vue?vue&type=template&id=f72c12de&scoped=true&"
import script from "./PurchaseBillView.vue?vue&type=script&lang=js&"
export * from "./PurchaseBillView.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseBillView.vue?vue&type=style&index=0&id=f72c12de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f72c12de",
  null
  
)

export default component.exports